var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOurApps = function SvgIconOurApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.631 39.144a2.645 2.645 0 1 1-5.29 0v-16.75h5.29zM35.447 3a3.526 3.526 0 0 1 3.526 3.526v12.342a3.526 3.526 0 0 1-3.526 3.526H26.63v-9.697a2.645 2.645 0 0 0-5.29 0v9.697h-8.815A3.526 3.526 0 0 1 9 18.868V6.526A3.526 3.526 0 0 1 12.526 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.554 44.355a2.204 2.204 0 0 1 0-3.117l9.35-9.35a2.204 2.204 0 1 1 3.117 3.116l-9.35 9.35c-.861.861-2.257.861-3.117 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.203 31.887c.86-.86 2.256-.86 3.117 0l9.35 9.35a2.204 2.204 0 0 1-3.116 3.117l-9.35-9.35a2.204 2.204 0 0 1 0-3.117"
  })));
};
export default SvgIconOurApps;